const PALETTE = [
  { min: 8,   bg: 'rgba(37,99,235,.15)',  border: 'rgba(37,99,235,.4)',  text: '#60a5fa' },
  { min: 6,   bg: 'rgba(22,163,74,.15)',  border: 'rgba(22,163,74,.4)',  text: '#4ade80' },
  { min: 4,   bg: 'rgba(234,88,12,.15)',  border: 'rgba(234,88,12,.4)',  text: '#fb923c' },
  { min: 0,   bg: 'rgba(220,38,38,.15)',  border: 'rgba(220,38,38,.4)',  text: '#f87171' },
];

const getColors = (score) => PALETTE.find((p) => score >= p.min) || PALETTE[PALETTE.length - 1];

export default function RatingBadge({ score, size = 'md' }) {
  if (!score) return null;
  const n = Number(score);
  if (isNaN(n) || n <= 0) return null;
  const { bg, border, text } = getColors(n);
  return (
    <span
      className={`rating-badge rating-badge--${size}`}
      style={{ background: bg, border: `1px solid ${border}`, color: text }}
    >
      ⭐ {n.toFixed(1)} MyAnimeList
    </span>
  );
}
